<template>
  <div class="main-container d-content">
    <div class="tableList">
      <data-table
        class="tableClass"
        :columns="fbpColums"
        :tableData="fbpData"
        :showinrow="true"
        @editStart="false"
        :showedit="false"
        :showdelete="false"
        :showhistory="false"
      >
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'claimNumber'">
            {{ slotprops.value.record.claim_no ? slotprops.value.record.claim_no : "" }}
          </p>
          <p v-if="slotprops.value.column.key == 'claimedDate'">
            {{ slotprops.value.record.for_month}}
          </p>

          <p v-if="slotprops.value.column.key == 'claimedAmount'">
            {{ slotprops.value.record.amount_claimed}}
          </p>
          <p v-if="slotprops.value.column.key == 'approvedAmount'">
            {{ slotprops.value.record.amount_approved }}
          </p>
          <p v-if="slotprops.value.column.key == 'status'">
            {{ slotprops.value.record.status }}
          </p>
        </template>
      </data-table>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  props:{
    componentName:String,
  },
  data() {
    return {
      fbpColums: [
        {
          label: "claim Number",
          key: "claimNumber",
        },
        {
          label: "Claim Month",
          key: "claimedDate",
        },
        {
          label: "Claimed Amount",
          key: "claimedAmount",
        },
        {
          label: "Approved Amount",
          key: "approvedAmount",
        },
        {
          label: "Status",
          key: "status",
        },
      ],
      fbpData: [],
    };
  },
  mounted(){
   this.fetchAllClaimHistory()
  },
  computed:{
    le_id() {
      return localStorage.getItem("le_id")
    },
    empId() {
      return localStorage.getItem("empId")
    },
  },
  methods:{
    ...mapActions({
      act_fetchAll: "dashboard/humanResource/fbpClaims/fetchAllClaimsHistory",
    }),
    async fetchAllClaimHistory(){
      try{
        this.fbpData=[]
        let empid = this.empId
         let res =await this.act_fetchAll(empid)
         res.data.payload.payload.map(element=>{
           if(element.details.details == this.componentName){
            this.fbpData.push(element)            
           }
         })
      }catch(error){
        
      }
    },
  }
};
</script>
<style scoped>
.tableList {
  margin-top: -90px;
  margin-left:-90px;
}
</style>
